import ApiBase from '@/api/base';

export default {
  getCallAnalytics (args) {
    return ApiBase.get(`/user/call_analytics`, args);
  },
};
